const SENSITIVE_IDENTIFIER_KEYWORDS = [
  'tckn',
  'tc kimlik',
  'tc-kimlik',
  'tckimlik',
  'kimlik',
  'identity number',
  'identity no',
  'identity',
  'pid',
  'bsn',
  'tckimlikno',
  'identitynumber',
  'doctortcno',
  'mothertcno',
  'fathertcno',
];

export function sanitizeSensitiveIdentifierMessage(
  message: unknown,
  replacement: string
): string {
  if (!message) {
    return replacement;
  }

  const normalizedMessage = String(message);
  const lowered = normalizedMessage.toLowerCase();
  const isSensitive = SENSITIVE_IDENTIFIER_KEYWORDS.some((keyword) =>
    lowered.includes(keyword)
  );

  return isSensitive ? replacement : normalizedMessage;
}
